module.exports = "<div class=\"jumbotron\">\n  <div class=\"container\">\n    <h1 class=\"display-3\">Page Not Found</h1>\n  </div>\n</div>\n\n<p>\n  The requested page could not be found! Make sure you typed it correctly or that it is a valid url.\n</p>\n"


//////////////////
// WEBPACK FOOTER
// D:/Development/Angular/grim3212.com/src/app/containers/error-pages/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/containers/error-pages/page-not-found/page-not-found.component.html
// module chunks = main